import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface User {
  id: number;
  username: string;
  email: string;
  telephone?: string;
  telephone_fixe?: string;
  photo_url?: string;
  is_active: boolean;
  role: string;
  hubspot_id?: string;
  createdAt: string | Date | null;
}

export interface UserUpdate {
  username?: string;
  email?: string;
  telephone?: string;
  telephone_fixe?: string;
  photo_url?: string;
  password?: string;
  hubspot_id?: string;
  role?: string;
  is_active?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private baseUrl = `${environment.apiUrl}${environment.apiEndpoint}/user`;

  constructor(private http: HttpClient) {}

  // Méthode utilitaire pour les headers
private getHeaders() {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      'Content-Type': 'application/json'
    }
  };
}

  // Méthodes existantes
  deleteUser(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`, this.getHeaders());
  }

  suspendUser(id: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/${id}/suspend`, {}, this.getHeaders());
  }

  activateUser(id: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/${id}/activate`, {}, this.getHeaders());
  }

  getUsers(): Observable<User[]> {
    return this.http.get<User[]>(this.baseUrl, this.getHeaders());
  }

  // NOUVELLES MÉTHODES MANQUANTES

  // Récupérer les détails d'un utilisateur spécifique
  getUserDetail(id: number): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}/${id}`, this.getHeaders());
  }

  // Mettre à jour un utilisateur
  updateUser(id: number, userData: UserUpdate): Observable<User> {
    return this.http.put<User>(`${this.baseUrl}/${id}`, userData, this.getHeaders());
  }

  // Récupérer son propre profil
  getMyProfile(): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}/me/profile`, this.getHeaders());
  }

  // Mettre à jour son propre profil
  updateMyProfile(userData: UserUpdate): Observable<User> {
    return this.http.put<User>(`${this.baseUrl}/me/profile`, userData, this.getHeaders());
  }

  // Changer le mot de passe
  changePassword(passwordData: { current_password: string; new_password: string }): Observable<any> {
    return this.http.post(`${this.baseUrl}/me/change-password`, passwordData, this.getHeaders());
  }

  // Uploader une photo de profil
  uploadProfilePhoto(formData: FormData): Observable<{ message: string; photo_url: string }> {
    return this.http.post<{ message: string; photo_url: string }>(
      `${this.baseUrl}/me/upload-photo`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`
          // Ne pas définir Content-Type pour que le browser le fasse automatiquement avec boundary
        }
      }
    );
  }

  // Supprimer la photo de profil
  deleteProfilePhoto(): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.baseUrl}/me/delete-photo`, this.getHeaders());
  }
}
